import React from 'react';
import _ from 'lodash';
import { useMutation, useQuery } from 'react-fetching-library';
import { Box, Modal, Card, CardContent, CardHeader, Checkbox, List, ListItem, ListItemText, ListItemIcon, ListItemButton, Button, Alert, IconButton, Stack, Typography } from '@mui/material';
import { getEndSalesReport, getCampsAction } from '../../../services/request';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloseIcon from '@mui/icons-material/Close';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

export default function GenerateSalesReportModal({ open, handleClose }) {
  const { mutate } = useMutation(getEndSalesReport);
  const { loading, payload, error } = useQuery(getCampsAction());
  const [checked, setChecked] = React.useState([]);
  const [camps, setCamps] = React.useState([]);

  React.useEffect(() => {
    if (!error && !loading) {
      setCamps(payload.results);
      setChecked(payload.results.map(camp => camp.id));
    }
  }, [loading]);

  const handleToggle = value => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleDownload = async () => {
    const { error: mutateError, payload: mutatePayload } = await mutate({ 'id_list': checked });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Zestawienie sprzedaży końcowe.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Card sx={{ ...style, width: '400px' }}>
        <CardHeader
          title="Wybierz turnusy"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          {error ? <Alert severity="error">Nie udało się pobrać listy turnusów</Alert> : null}
          <List>
            {camps.map(camp => {
              const labelId = `checkbox-list-label-${camp.id}`;

              return (
                <ListItem
                  key={camp.id}
                  disablePadding
                >
                  <ListItemButton role={undefined} onClick={handleToggle(camp.id)} dense>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(camp.id) !== -1}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': labelId }}
                      />
                    </ListItemIcon>
                    <ListItemText id={labelId} primary={camp.name} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
          <Box height={40}/>
          <Stack direction="rop" justifyContent="flex-end">
            <Typography variant="body2">Liczba wybranych turnusów:</Typography>
            <Box width={5}/>
            <Typography variant="body2" fontWeight="bold">{checked.length}</Typography>
          </Stack>
          <Box height={20}/>
          <Button
            variant="contained"
            onClick={handleDownload}
            disabled={checked.length === 0}
            endIcon={<FileDownloadIcon/>}
          >
            Pobierz
          </Button>
        </CardContent>
      </Card>
    </Modal>);
};
